
import {
  Modal,
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";

type Airline = {
  _id: string;
  airlineName: string;
  airlineTwolettercode: string;
  airlineCode: string;
};

interface Props {
  open: boolean;
  handleClose: () => void;
  airLines: Airline[];
}

const boxStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  bgcolor: "background.paper",
  // boxShadow: 24,
  borderRadius: 2,
  // p: 3,
  maxHeight: "90vh",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export default function AirShippingShowModal({ open, handleClose, airLines }: Props) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={boxStyle}>
        <div className="modalTableHeading">
          <h3>Active Airlines</h3>
        </div>

        <div className="tableModalBody">
          <div className="tableModalResponsive">
            <TableContainer
              component={Paper}
              sx={{
                flex: 1,
                overflowY: "auto",
                maxHeight: "100%",
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Airline Name</TableCell>
                    <TableCell>IATA Code</TableCell>
                    <TableCell>Airline Code</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {airLines?.length > 0 ? (
                    airLines?.map((line) => (
                      <TableRow key={line._id}>
                        <TableCell>
                          {line?.airlineName}
                        </TableCell>
                        <TableCell>
                          {line?.airlineTwolettercode}
                        </TableCell>
                        <TableCell>
                          {line?.airlineCode}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        No data available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </Box>
    </Modal>
  );
}
